module.exports = __webpack_public_path__ + "static/media/34-2.736245dd.mp3";